import { render } from "./MessageSelectorPage.vue?vue&type=template&id=e3c29c38&scoped=true"
import script from "./MessageSelectorPage.vue?vue&type=script&lang=js"
export * from "./MessageSelectorPage.vue?vue&type=script&lang=js"

import "./MessageSelectorPage.vue?vue&type=style&index=0&id=e3c29c38&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c29c38"]])

export default __exports__